export const environment = {
  production: true,
  // old
  // baseIP: "https://crmdev.bentraytech.com/",
  // apiPrefix: "api/web/v1/",

  //live
  baseIP: "https://crmbackend.tukisuite.com/",
  apiPrefix: "api/web/v1/",


  // dev
  // baseIP: "https://crmdemo.bentraytech.com/",
  // apiPrefix: "api/web/v1/",


  defaultImageUrl: "./assets/images/",
  defaultImagePath: "./assets/dist/img",
};
